<div class="td-wb-form"
     id="td-wb-exchange-agreements-modal">

  <!-- Modal Header -->
  <td-wb-modal-header iconId="tertiary--agreements"
                      class="td-wb-modal__header">
    <td-wb-modal-header-title modalTitle="tdWb.platform.preferences.agreements.EXCHANGE_AGREEMENTS">
    </td-wb-modal-header-title>
    <td-wb-modal-header-buttons>
      <td-wb-modal-close-button></td-wb-modal-close-button>
    </td-wb-modal-header-buttons>
  </td-wb-modal-header>
  <!-- Agreement Components Switch -->
  <td-wb-modal-panel class="td-wb-form__body td-wb-form__agreements td-wb-current-agreements__container">
    @switch (currentAgreement?.agreementType) {
      @case ('AMEX') {
        <td-wb-amex-agreement [disabled]="isDisabled()"></td-wb-amex-agreement>
      }
      @case ('CEG') {
        <td-wb-ceg-agreement [disabled]="isDisabled()"></td-wb-ceg-agreement>
      }
      @case ('ME') {
        <td-wb-me-agreement [disabled]="isDisabled()"></td-wb-me-agreement>
      }
      @case ('NASDAQ') {
        <td-wb-nasdaq-agreement [disabled]="isDisabled()"></td-wb-nasdaq-agreement>
      }
      @case ('NYSE') {
        <td-wb-nyse-agreement [disabled]="isDisabled()"></td-wb-nyse-agreement>
      }
      @case ('OPRA') {
        <td-wb-opra-agreement [disabled]="isDisabled()"></td-wb-opra-agreement>
      }
      @case ('USOTC') {
        <td-wb-usotc-agreement [disabled]="isDisabled()"></td-wb-usotc-agreement>
      }
      @case ('CMSPDJ') {
        <td-wb-cme-agreement [disabled]="isDisabled()"></td-wb-cme-agreement>
      }
      @case ('LSEGRU') {
        <td-wb-russel-agreement [disabled]="isDisabled()"></td-wb-russel-agreement>
      }
      @case ('IEX') {
        <td-wb-iex-agreement [disabled]="isDisabled()"></td-wb-iex-agreement>
      }
      @case ('TDW_TERMS_AND_CONDITIONS') {
        <td-wb-td-agreement [disabled]="isDisabled()"></td-wb-td-agreement>
      }
    }
  </td-wb-modal-panel>
  <!-- Bottom/footer bar -->
  <td-wb-sticky-panel-bottom class="td-wb-agreements__button-container">
    <td-wb-sticky-panel-bottom-content>
      <td-wb-page-action-panel position="end"
                               class="td-wb-row__button-container">
        @if (!isDisabled()) {
          <button class="td-wb-agreements__button"
                  id="td-wb-current-agreements-reject-button"
                  type="button"
                  tdWbButton
                  tdWbButtonType="secondary"
                  (click)="declineAgreement()">
            <span translate="tdWb.platform.preferences.agreements.REJECT"></span>
          </button>
        }
        @if (!isDisabled()) {
          <button class="td-wb-agreements__button"
                  type="button"
                  id="td-wb-current-agreements-accept-button"
                  tdWbButton
                  tdWbButtonType="primary"
                  (click)="acceptAgreement()">
            <span translate="tdWb.platform.preferences.agreements.ACCEPT"></span>
          </button>
        }
        @if (isDisabled()) {
          <button class="td-wb-agreements__button"
                  type="button"
                  id="td-wb-current-agreements-close-button"
                  tdWbModalClose
                  tdWbButton
                  tdWbButtonType="primary">
            <span translate="tdWb.platform.preferences.agreements.CLOSE"></span>
          </button>
        }
      </td-wb-page-action-panel>
    </td-wb-sticky-panel-bottom-content>
  </td-wb-sticky-panel-bottom>
</div>
